
const formTransacao = () => import('./form')
const astroPayCard = () => import('../astroPay/card')
const astroPayCardComp = () => import('../astroPay/comprovante')

export default [
  {
    path: '/transacao/:id',
    name: 'transacao.index',
    component: formTransacao
  },
  {
    path: '/transacao/picpay/:picPayId',
    name: 'transacao.picpay.index',
    component: formTransacao
  },
  {
    path: '/transacao/:id/astropay',
    name: 'transacao.astropay.index',
    component: astroPayCard
  },
  {
    path: '/transacao/:id/astropay/view',
    name: 'transacao.astropay.view',
    component: astroPayCardComp
  }
]



// WEBPACK FOOTER //
// ./src/features/admin/transacoes/routes.js